import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: $setup.state.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.state.refreshing = $event)),
    onRefresh: $setup.onRefresh
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_list, {
        loading: $setup.state.loading,
        "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ($setup.state.loading = $event)),
        finished: $setup.state.finished,
        "finished-text": "没有更多了",
        onLoad: $setup.onLoad,
        ref: "list"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["loading", "finished", "onLoad"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}